var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper columns is-centered"},[_c('div',{staticClass:"column is-4-desktop is-6-tablet is-8-mobile is-offset-2-mobile"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }